import { Component, OnInit, Input } from '@angular/core';
import { ComponentBase } from 'src/app/base-classes/componet-base';
import { ExamTestService } from '../../../exams/services/exam-test.service';
import { Template } from 'src/app/models/template';

@Component({
  selector: 'app-exam-lobby-info',
  templateUrl: './exam-lobby-info.component.html',
  styleUrls: ['./exam-lobby-info.component.scss']
})
export class ExamLobbyInfoComponent extends ComponentBase implements OnInit {

  constructor(private examTestService: ExamTestService) { super(); }

  @Input() examTestId: number;
  examInfoTemplate: Template;

  ngOnInit() {
    let sub =  this.examTestService.getExamLobbyInfo(this.examTestId)
    .subscribe(res => {
      this.examInfoTemplate = res;
    });
    this.addSubscription(sub);
  }

}
